











import Vue from 'vue'
import SudentsMessenger from '@/components/Students/sudentMesseger.vue'
import Student from '@/models/Students/Student'
import { USER_ROLE_CHAT } from '@/constants'

export default Vue.extend({
  components: {SudentsMessenger},
  props: {
    scope: {} as () => {student: Student}
  },
  computed: {
    admin (): boolean {
      if (this.$store.state.user.user) {
        return this.$store.state.user.user.checkRole(USER_ROLE_CHAT)
      }
      return false
    }
  }
})
